import { render, staticRenderFns } from "./onReview2.vue?vue&type=template&id=03618630&scoped=true"
import script from "./onReview2.vue?vue&type=script&lang=js"
export * from "./onReview2.vue?vue&type=script&lang=js"
import style0 from "./onReview2.vue?vue&type=style&index=0&id=03618630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03618630",
  null
  
)

export default component.exports